import { Button, CrossMd, P, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

const InputPillLabel = styled(P)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const InputPillWrapper = styled.div`
  display: flex;
  padding: ${spacingHelper('twoExtraSmall twoExtraSmall twoExtraSmall medium')};
  background-color: ${paletteHelper('backgroundSecondary')};
  border-radius: ${spacingHelper('extraSmall')};
  align-items: center;
  justify-content: space-between;
`;

export const InputPill: FunctionComponent<{ label: string; onClear: () => void }> = ({
  label,
  onClear,
}) => (
  <InputPillWrapper>
    <InputPillLabel variant="body01"> {label}</InputPillLabel>
    <Button
      onClick={onClear}
      icon={<CrossMd />}
      variant="naked"
      hideLabel
      compact
      aria-label="clear point of interest"
    />
  </InputPillWrapper>
);
